<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="welcome-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="desc">梦梦见面礼来了，请查收！</div>
                    
                    <div class="welcome-view flex-center-center">
                        <div class="rb">
                            <div class="amt">X1</div>
                            <div class="status icon sprite-status-dismiss" v-if="($store.state.userinfo.uflag & 1) == 1"></div>
                        </div>

                        <div class="game-item">
                            <div class="icon-wrapper">
                                <div class="reward-pic" v-tips="'KR48'"><game-item :locked="true" :id="'KR48'" :num="3"></game-item></div>
                            </div>
                            <p class="item-name">活跃自选礼包(7天)</p>
                            <div class="status icon sprite-status-dismiss" v-if="($store.state.userinfo.uflag & 1) == 1"></div>
                        </div>
                       
                    </div>
                    
                    <!-- <div class="u-btn apply" @click="apply()" :class="{'dismiss' : ($store.state.userinfo.uflag & 1) == 1}"></div> -->

                    <div class="notice">奖励已发放至军师邮箱或网页活动！</div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>

.welcome-modal{
    width: 690px;
    height: 413px;
    background-image: url(~@/assets/images/modal/bg-modal-welcome.png);  
}

.title{
    width: 100%;
    height: 49px;
    margin: 0 auto 10px;
    background-repeat : no-repeat;
    background-position : center;
    background-image: url(~@/assets/images/modal/title-welcome.png);     
}

.desc{
    text-align: center;
    color: #f8e1dc;
}

.welcome-view{
    width: 615px;
    height: 164px;
    margin: 10px auto 10px;
    background-image: url(~@/assets/images/modal/welcome-view.png);  
}

.rb{
    position: relative;
    width: 117px;
    height: 119px;
    margin: 0 55px;
    background-image: url(~@/assets/images/modal/icon-rb.png);

    .status{
        position: absolute;
        top: 55px;
        left: 50%;
        transform: translateX(-50%);        
    }
}

.amt{
    position: absolute;
    top: 72px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 45px;
    height: 27px;
    line-height: 27px;
    background-image: url(~@/assets/images/modal/bg-cnt.png);
    font-size: 25px;
    color: #ffcc83;
    font-family: "HYJinKaiJ";
    font-weight: 400;
    text-align: center;
}

.game-item{
    position: relative;
    height: 117px;
    margin: 0 55px;

    .status{
        position: absolute;
        top: 45px;
        left: 50%;
        transform: translateX(-50%);        
    }    
}

.icon-wrapper{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 84px;
    height: 84px;
    margin: 0 auto 10px;
    background-image: url(~@/assets/images/modal/bg-item.png);


    &.dismiss::after{
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url(~@/assets/images/pc/icon-get.png);
        background-color: rgba($color: #000000, $alpha: 0.55);
        background-position: center;
        background-repeat: no-repeat;
        z-index: 1;              
    }

    .reward-pic{
        width: 68px;
        height: 68px;
    }
}

.item-name{
    font-size: 20px;
    color: #fee1ae;
}

.u-btn.apply{
    width: 254px;
    height: 83px;
    margin: 0 auto;
    background-image: url(~@/assets/images/modal/btn-apply.png);
}

.notice{
    margin-top: 30px;
    color: #ffb864;
    text-align: center;
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            type : 'notice',
            pack_config : {
                'WH16' : {
                    name : '梦梦见面礼一',
                },
                'WH17' : {
                    name : '梦梦见面礼二',
                },
                'WH18' : {
                    name : '梦梦见面礼三',
                },
                'WH19' : {
                    name : '梦梦见面礼四',
                },
                'WH20' : {
                    name : '梦梦见面礼五',
                },
                'WH21' : {
                    name : '梦梦见面礼六',
                },                                                                               
            },
        }
    },
    computed: {
        welcome_gift_id(){
            return this.$store.state.userinfo.userName || 'KQ62';
        },
        welcome_gift(){
            return this.pack_config[this.welcome_gift_id] || {};
        },
        welcome_gift_name(){
            return this.$store.state.userinfo.zid ? (this.welcome_gift.name || '梦梦见面礼') : '梦梦见面礼';
        },
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },           
        closeModal(){
            const onClose = this.onClose;
            this.destroyElement();
            if(typeof onClose === 'function')onClose();
        },
    },
}
</script>